// extracted by mini-css-extract-plugin
export default {"container":"CreateSpecialCampaign_container__RbbwT","wrapperCard":"CreateSpecialCampaign_wrapperCard__5CANa"};